<template>
  <div id="appChat" class="chat-app" v-show="visible">
    <div class="chat-app-header" @dblclick="toggleWindow()">
      <a-row>
        <a-col :span="12" class="padding-l-5">
          <h5 class="text-white">消息中心</h5>
        </a-col>
        <a-col :span="12" class="text-right padding-r-5 padding-t-4">
          <div
            class="chat-toolbar display-flex align-center justify-end padding-t-2"
          >
            <a
              title="最大化"
              @click="maxWindow"
              v-if="windowSize == 'restore'"
              class="display-flex align-center justify-center"
            >
              <!--<icon-font type="icon-max"></icon-font>-->
              <svg class="icon" style="width: 16px; height: 16px">
                <use xlink:href="#icon-fangda"></use>
              </svg>
            </a>
            <a
              title="最小化"
              @click="restoreWindow"
              v-if="windowSize == 'max'"
              class="display-flex align-center justify-center"
            >
              <!--<icon-font type="icon-restore"></icon-font>-->
              <svg class="icon">
                <use xlink:href="#icon-suoxiao"></use>
              </svg>
            </a>
            <a
              title="关闭"
              @click.stop="closeWindow"
              class="display-flex align-center justify-center"
            >
              <!--<a-icon type="close"></a-icon>-->
              <svg class="icon margin-l-10 close-icon">
                <use xlink:href="#icon-guanbi2"></use>
              </svg>
            </a>
          </div>
        </a-col>
      </a-row>
    </div>
    <div class="chat-app-body">
      <iframe
        id="chatIframe"
        :src="imSrc"
        width="100%"
        height="100%"
        frameborder="no"
        border="0"
        marginwidth="0"
        marginheight="0"
        allowtransparency="yes"
        scrolling="no"
      ></iframe>
    </div>
  </div>
</template>

<script>
  import { ref, computed, onMounted, reactive, toRefs } from 'vue'
  import { useRoute, useRouter } from 'vue-router'
  import { useStore } from 'vuex'
  export default {
    props: ['visible'],
    setup(props, ctx) {
      const state = reactive({
        imSrc: window.config.im,
        windowSize: 'restore',
      })

      const store = useStore()
      const route = useRoute()
      const router = useRouter()

      onMounted(() => {
        const imIframe = document.getElementById('chatIframe')
        const imWindow = imIframe.contentWindow
        const iolcode = localStorage.iolcode || ''
        imIframe.onload = () => {
          setTimeout(() => {
            imWindow.postMessage(iolcode, '*')
          }, 4000)
          window.addEventListener(
            'message',
            (e) => {
              if (typeof e.data == 'string' && e.data.includes('http')) {
                closeWindow()
                window.location.href = e.data
              } else if (typeof e.data == 'number') {
                ctx.emit('getVisible', e.data)
              } else if (
                typeof e.data == 'string' &&
                e.data.includes('toWebcat')
              ) {
                toWebcat(e.data)
              } else if (
                typeof e.data == 'string' &&
                e.data.includes('twinslator/officialList')
              ) {
                closeWindow()
                router.push({
                  path: '/twinslator/officialList',
                  query: {
                    cooperate: e.data.split('?cooperate=')[1],
                  },
                })
              }
            },
            true
          )
        }
        drag($('#appChat'))
        $(window).resize(() => {
          drag($('#appChat'))
        })
      })
      // 最大化 maxWindow
      const maxWindow = () => {
        $('#appChat').css({
          width: '100%',
          height: '100%',
        })
        drag($('#appChat'))
        state.windowSize = 'max'
      }

      // 双击 toggleWindow
      const toggleWindow = () => {
        if (state.windowSize === 'restore') {
          maxWindow()
        } else if (state.windowSize === 'max') {
          restoreWindow()
        }
      }

      // restore
      const restoreWindow = () => {
        $('#appChat').css({
          width: '800px',
          height: '530px',
        })
        drag($('#appChat'))
        state.windowSize = 'restore'
      }

      // 关闭
      const closeWindow = () => {
        ctx.emit('getVisible', false)
      }

      // drag
      const drag = (obj) => {
        let head = obj.find('.chat-app-header')
        let body = obj.find('.chat-app-body')
        let chatW = obj.width()
        let chatH = obj.height()
        let winW = $(window).width()
        let winH = $(window).height()
        let mask, gapX, gapY
        obj.css({
          margin: 0,
          top: (winH - chatH) / 2 + 'px',
          left: (winW - chatW) / 2 + 'px',
        })

        head.unbind('mousedown').bind('mousedown', start)

        function start(event) {
          gapX = event.clientX - obj.offset().left
          gapY = event.clientY - obj.offset().top
          $(document).bind('mousemove', move)
          $(document).bind('mouseup', stop)
          mask = $('<div></div>')
          mask.css({
            position: 'absolute',
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
          })
          body.append(mask)
          return false
        }

        function move(event) {
          let x =
            event.clientX - gapX < 0
              ? 0
              : event.clientX - gapX > winW - chatW
                ? winW - chatW
                : event.clientX - gapX
          let y =
            event.clientY - gapY < 0
              ? 0
              : event.clientY - gapY > winH - chatH
                ? winH - chatH
                : event.clientY - gapY
          obj.css({
            left: x + 'px',
            top: y + 'px',
          })
          return false
        }

        function stop() {
          $(document).unbind('mousemove', move)
          $(document).unbind('mouseup', stop)
          if (mask) {
            mask.remove()
          }
        }
      }

      //在IM里面打开webcat
      const toWebcat = (data) => {
        const apiDomain = window.config.webcat //域名
        const taskId = data.split('/')[1]
        let win = window.open('')
        // webcatGenerateKey().then((res) => {
        //   win.location.href =
        //     apiDomain + "/?webcatKey=" + res.data + "&taskId=" + taskId;
        // });
      }

      return {
        ...toRefs(state),
        maxWindow,
        toggleWindow,
        restoreWindow,
        closeWindow,
        toWebcat,
      }
    },
  }
</script>

<style lang="scss" scoped>
  .chat-app {
    width: 800px;
    height: 530px;
    position: fixed;
    left: 50%;
    top: 50%;
    margin-top: -265px;
    margin-left: -400px;
    z-index: 999999;
    border-radius: 4px;
    box-shadow: 2px 2px 15px rgba(0, 0, 0, 0.2);
    &:after {
      content: '';
      position: fixed;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      background: #000;
      opacity: 0.2;
      z-index: -1;
    }
  }
  .chat-app-header {
    background: #fff;
    color: #fff;
    height: 30px;
    background: #333;
    border-radius: 4px 4px 0 0;
    line-height: 30px;
    position: relative;
    cursor: move;
    .chat-toolbar {
      a {
        color: #fff;
      }
      svg {
        width: 20px;
        height: 20px;
        outline: none;
        fill: #fff;
      }
    }
    .chat-app-close {
      font-size: 24px;
    }
    .text-white {
      color: #fff;
    }
  }
  .chat-app-body {
    top: 30px;
    left: 0;
    right: 0;
    bottom: 0;
    position: absolute;
  }
</style>
